const { VUE_APP_PLATFORM_NAME } = process.env;

const ExcelJS = require("exceljs");
const moment = require("moment");

const downloadFile = require("./utils/downloadFile");
const header = require("./modules/header");
const formatName = require("./utils/formatName");
const PAYMENT = require("../payment.js").default;

const store = require("../../store").default;

module.exports = async ({ party, tickets, payments, filters, ticketBlocksMap }) => {
  const opMode = store?.getters["auth/config"]?.opMode || false;
  const ramdomPassword = Math.random().toString(36).slice(-8);
  if (!opMode) console.log("Excel protegido com a senha: ", ramdomPassword);

  const workbook = new ExcelJS.Workbook();
  workbook.creator = VUE_APP_PLATFORM_NAME;
  workbook.lastModifiedBy = VUE_APP_PLATFORM_NAME;

  workbook.title = `Resumo de vendas - ${formatName(party.name)}`;
  workbook.created = new Date();

  const sheet = workbook.addWorksheet("Resumo", {
    properties: { tabColor: { argb: "242939" } },
    views: [{ showGridLines: false }]
  })
  ''
  const interestedData = () => ({
    count: 0,
    sale: 0,
    value: 0,
    courtesy: 0,
    validated: 0,
  })
  const reducedTickets = tickets.reduce((acc, t) => {
    const block = t.TicketBlock;
    const group = block.TicketGroup;
    const isCourtesy = t.Payment.paymentType === "COURTESY";

    if (!acc.ticketGroups[group.id])
      acc.ticketGroups[group.id] = {
        name: group.name,
        id: group.id,
        TicketBlock: {},
        total: interestedData(),
      };

    acc.ticketGroups[group.id].total.count++;
    acc.ticketGroups[group.id].total.value += t.amount - t.platformFee;
    if (isCourtesy) acc.ticketGroups[group.id].total.courtesy++;
    else acc.ticketGroups[group.id].total.sale++;
    if (t._count.TicketEntry) acc.ticketGroups[group.id].total.validated++;

    if (!acc.ticketGroups[group.id].TicketBlock[block.id])
      acc.ticketGroups[group.id].TicketBlock[block.id] = {
        originalPrice: ticketBlocksMap[block.id]?.price,
        name: block.name,
        ...interestedData(),
      };

    acc.ticketGroups[group.id].TicketBlock[block.id].count++;
    acc.ticketGroups[group.id].TicketBlock[block.id].value += t.amount - t.platformFee;
    if (isCourtesy) acc.ticketGroups[group.id].TicketBlock[block.id].courtesy++;
    else acc.ticketGroups[group.id].TicketBlock[block.id].sale++;
    if (t._count.TicketEntry)
      acc.ticketGroups[group.id].TicketBlock[block.id].validated++;
    return acc;
  }, {
    ticketGroups: {},
    paymentMethods: {},
  });
  
  const data = reducedTickets.ticketGroups;
  const ticketGroupsList = Object.values(data).sort((a, b) => a.name.localeCompare(b.name));

  const columns = [
    { key: "name", width: 50 },
    { key: "sales", width: 15 },
    { key: "courtesy", width: 18 },
    { key: "totalTickets", width: 20 },
    { key: "validated", width: 20 },
    { key: "averageTicket", width: 20 },
    { key: "totalValue", width: 20 },
  ];
  sheet.columns = columns.flat();
  sheet.columns.forEach((column, index) => {
    if (!index) column.alignment = { vertical: "middle", horizontal: "left" };
    else column.alignment = { vertical: "middle", horizontal: "center" };
  });
  applyStyle(sheet, {
    font: { name: "Courier New" }
  });


  await header(workbook, sheet, { title: "Resumo de vendas", party, filters });

  // Dados
  const lastColumn = String.fromCharCode(65 + columns.length - 1);
  ticketGroupsList.forEach((ticketGroup) => {
    const r = sheet.addRow({ name: ticketGroup.name });
    r.font = { bold: true, size: 14 };
    r.alignment = { horizontal: "center" };
    r.height = 50;
    r.eachCell((cell) => { cell.border = { bottom: { style: "thin" }, top: { style: "medium" } }; })


    // header 
    sheet.mergeCells(`A${r.number}:${lastColumn}${r.number}`);
    for (let i = 1; i <= columns.length; i++) {
      r.getCell(i).font = { name: "Courier New", bold: true, size: 12, color: { argb: "295f99" } };
    }

    // add columns
    const hRow = sheet.addRow({
      name: `Setor • ${ticketGroup.name}`,
      sales: "Vendas",
      courtesy: "Cortesias",
      totalTickets: "Total Ingressos",
      averageTicket: "Ticket Médio",
      validated: "Validados",
      totalValue: "Valor Total",
    });
    hRow.font = { name: "Courier New", bold: true, size: 12 };
    const ticketBlocks = Object.values(ticketGroup.TicketBlock);
    ticketBlocks.forEach((ticketBlock) => {
      var tbRow = sheet.addRow({
        name: ticketBlock.name,
        sales: ticketBlock.sale,
        courtesy: ticketBlock.courtesy,
        totalTickets: ticketBlock.count,
        averageTicket: {
          formula: `G${sheet.rowCount + 1} / D${sheet.rowCount + 1}`,
          result: ticketBlock.value / ticketBlock.count,
        },
        validated: ticketBlock.validated,
        totalValue: ticketBlock.value,
      });

      tbRow.getCell(6).numFmt = '"R$"#,##0.00;[Red]-"R$"#,##0.00';
      tbRow.getCell(7).numFmt = '"R$"#,##0.00;[Red]-"R$"#,##0.00';
    });

    // Total row
    const initialRow = sheet.rowCount - ticketGroup.TicketBlock.length;
    const totalRow = sheet.addRow({
      name: "Sub-Total",
      sales: ticketGroup.total.sale,
      courtesy: ticketGroup.total.courtesy,
      totalTickets: ticketGroup.total.count,
      validated: ticketGroup.total.validated,
      averageTicket: ticketGroup.total.value / ticketGroup.total.count,
      totalValue: ticketGroup.total.value,
    });

    totalRow.getCell(1).alignment = { horizontal: "right" };
    totalRow.getCell(6).numFmt = '"R$"#,##0.00;[Red]-"R$"#,##0.00';
    totalRow.getCell(7).numFmt = '"R$"#,##0.00;[Red]-"R$"#,##0.00';
    totalRow.font = { name: "Courier New", bold: true, color: { argb: "FF0000" } };
    totalRow.eachCell((cell) => { cell.border = { top: { style: "dotted" } }; });
    totalRow.height = 18;

    // Empty row
    sheet.addRow([]);
  });

  sheet.addRow([]);

  const totalValue = ticketGroupsList.reduce((acc, { total }) => {
    return {
      sale: acc.sale + total.sale,
      courtesy: acc.courtesy + total.courtesy,
      count: acc.count + total.count,
      value: acc.value + total.value,
      validated: acc.validated + total.validated,
    }
  }, { sale: 0, courtesy: 0, count: 0, value: 0, validated: 0 });

  const totalRow = sheet.addRow({
    name: "Total",
    sales: totalValue.sale,
    courtesy: totalValue.courtesy,
    totalTickets: totalValue.count,
    averageTicket: totalValue.value / totalValue.count,
    validated: totalValue.validated,
    totalValue: totalValue.value,
  });

  totalRow.height = 30;
  totalRow.font = { name: "Courier New", bold: true, color: { argb: "FF0000" } };
  totalRow.alignment = { vertical: "middle", horizontal: "center" };
  totalRow.getCell(6).numFmt = '"R$"#,##0.00;[Red]-"R$"#,##0.00';
  totalRow.getCell(7).numFmt = '"R$"#,##0.00;[Red]-"R$"#,##0.00';
  totalRow.getCell(1).alignment = { horizontal: "right", vertical: "middle" };
  totalRow.eachCell((cell, i) => {
    cell.border = {
      top: { style: "double" },
      bottom: { style: "double" },
      left: i === 1 ? { style: "double" } : undefined,
      right: i === 7 ? { style: "double" } : undefined,
    };
  });


  const timestempRow = sheet.addRow({ name: moment().format("DD [de] MMMM [de] YYYY   HH:mm:ss") });
  timestempRow.font = { size: 10 };
  timestempRow.alignment = { horizontal: "right" };
  timestempRow.height = 50;
  sheet.mergeCells(`A${timestempRow.number}:${lastColumn}${timestempRow.number}`);

  // Protect sheet
  if (!opMode)
    sheet.protect(ramdomPassword, {
      sort: true,
      autoFilter: true,
      selectLockedCells: false,
    });


  downloadFile(workbook, `Resumo de vendas - ${party.name}`);
  return true;
};


function applyStyle(sheet, style) {
  const { font, alignment } = style;
  sheet.columns.forEach((column, index) => {
    if (font) column.font = font;
    if (alignment) column.alignment = alignment;
  });
}

